import cookies from "./cookies"
import skey from './session/skey'
import pskey from './session/pskey'
import wechat from './session/wechat'
import dummy from './session/dummy'
import qqconnect from './session/qqconnect'

export default function getSessionCookie() {
  let openid = cookies.get("midas_txcz_openid")
  let openkey = cookies.get("midas_txcz_openkey")
  let sessionid = cookies.get("midas_txcz_sessionid")
  let sessiontype = cookies.get("midas_txcz_sessiontype")

  let wxAppid2 = cookies.get("midas_txcz_wxAppid2")
  let qqAppid = cookies.get("midas_txcz_qqAppid")


  if (!sessiontype) {
    return false
  }

  if (!openid || !openkey) {
    return false
  }

  switch(true) {
    case sessiontype.indexOf('pskey_') > -1:
      return new pskey({
        uin: openid.replace(/^o?0*/,''),
        pskey: openkey,
        sessiontype: sessiontype
      })

    case sessiontype === 'skey':
      return new skey({
        uin: openid.replace(/^o?0*/,''),
        skey: openkey
      })

    case sessiontype === 'kp_actoken':
      return new qqconnect({
        openid: openid,
        payToken: openkey,
        qq_appid: qqAppid
      })

    case sessiontype === 'kp_accesstoken':
      return new qqconnect({
        openid: openid,
        accessToken: openkey,
        qq_appid: qqAppid
      })


    case sessiontype === 'wc_actoken':
      return new wechat({
        appid: wxAppid2 || 'wx951bdcac522929b6',
        openid: openid,
        accessToken: openkey
      })

    case sessiontype === 'st_dummy':
      return new dummy({
        openid: openid,
        openkey: openkey
      })

    default:
      return false
  }
}
